import {Wrapper} from "./shoppingCart.style";
import {CartSection} from "./section/cart";
import {memo} from "react";

export const ShoppingCartPage = memo(() => {
    return (
        <Wrapper>
            <CartSection/>
        </Wrapper>
    )
})